const messages = {
    availPoints: "Tilgængelige point",
    awaitingPoints: "Afventende point",
  board: {
    title: "Dashboard",
    title2: "Ydelsesanimering {year}",
    headline1: "Dine kampagner og point på et øjeblik",
    headline2: "Optjen point for dine dækkøb.",
    pointsBalanceToDate: "POINTSALDO PR. DATO",
    availPoints: "Tilgængelige point",
    awaitingPoints: "Afventende point",
    yourRealisation: "DINE PRÆSTATIONER",
    yourEngagement: "Dit årlige engagement: <b>{tyres} dæk</b>",
    yourPoints: "DINE POINT",
    yourRetailPurchase: "DINE DETAILHANDELSKØB",
    yourRetailPurchaseCCS: "DIT DETAILSALG",
    pointsByPurchase: "point optjent ved dine køb",
    pointsByBoosters: "point optjent via boostere",
    pointsByBSPurchase: "Point optjent ved dine Bridgestone-køb",
    pointsByBSPurchaseCCS:
      "Point optjent ved dit salg af Bridgestone-dæk",
    remaining: "Resterende dæk",
    yourGoal: "Fremskridt mod målet",
    unit: "dæk",
    buttons: {
      learnMore: "Læs mere om dine point",
      learnMoreAboutMechanism: "Læs mere om mekanismen",
    },
    charts: {
      byBrand: "Efter mærke",
      bySize: "Efter<br/>fælgstørrelse",
    },
    exploreResults: "Se dine resultater",
    tyreLimitInfo:
      "Der kræves et minimumsudsolgt volumen på 50 Bridgestone- og/eller Firestone-dæk for hver Booster-kampagneperiode",
  },
  charts: {
    byBrand: "Efter mærke",
    bySize: "efter fælgstørrelse",
  },

  dashboard: {
    dashboardTitle: "Dine fordele",
    dashboardBox: {
      title: "Pointbalance",
      description: "Dit aktuelle samlede antal marketingpoint",
      availPoints: "Tilgængelige point",
      awaitingPoints: "Afventende point",
      lastUpdate: "Seneste opdatering",
      button: "Læs mere",
      points: "point",
    },
  },
  soldTyres: "SOLGTE DÆK",
  receivedPoints: "OPTJENTE POINT",
  boosterCCS: {
    personalInfo: "Personlige oplysninger",
    csNumberTitle: "Angiv venligst deltagende kontonummer(e)",
    tyresTitle: "Angiv venligst antallet af solgte dæk",
    minTyresInfo:
      "Der kræves minimum {tyres} Bridgestone/Firestone-dæk. Kompensation gælder kun for Bridgestone-dæk.",
    tyresAmount: "Antal dæk",
    filesTitle: "Upload venligst dokumentation for dit salg",
    filesDescription:
      "Bemærk: Kun salg med angivelse af dækfælgstørrelse medtages.",
    addAnotherFile: "Tilføj et dokument til",
    file: "Upload dokument",
    formatInfo:
      "Accepterede filformater: xlsx, jpeg og pdf. Maksimal filstørrelse: 8 MB",
    confrimationMessage:
      "<b>Tak for din deltagelse!</b> <br/>Din anmodning er modtaget og sendt til Bridgestone til validering.<br/>Du modtager en e-mail med resultatet af din deltagelse i Booster CCS.<br/>Vi ses snart på Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Del point",
    forShare: "Point du vil dele",
    title: "Titel",
  },
  notFoundFile: "Intet valgt",
  chooseFile: "Vælg fil",
};
export default {
  messages,
};
